import { APP_ROUTES, getQueryValue } from '@zorro/common-utils';
import { Breadcrumbs } from '@zorro/design-system/v2/Breadcrumbs';
import { router } from 'next/client';

const createRoutes = (isDemo: boolean) => {
  return [
    {
      title: 'All employers',
      href: isDemo
        ? APP_ROUTES.OPS_DEMO_EMPLOYERS()
        : APP_ROUTES.OPS_EMPLOYERS(),
    },
    {
      title: 'New employer',
      href: APP_ROUTES.OPS_ADD_EMPLOYER_COMPANY_DETAILS(),
    },
  ];
};

export const AddEmployerBreadcrumbs = () => {
  const isDemoWhenAddingNewEmployer =
    getQueryValue(router.query.isDemo) === 'true' || false;
  return (
    <Breadcrumbs items={createRoutes(isDemoWhenAddingNewEmployer)} mb="1rem" />
  );
};
